import {
    CREATE_USER,
    CREATE_USER_SUCCESS,
    API_ERROR,VERIFY_OTP_NUMBER,VERIFY_OTP_NUMBER_SUCCESS,GET_ACCOUNT_INFO
  } from "./actionTypes"
  
  const initialState = {
    registrationError: null,
    message: null,
    loading: false,
    authData: null,
  }
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_USER:
        state = {
          ...state,
          loading: true,
          registrationError: null,
        }
        break
      case GET_ACCOUNT_INFO:
        state = {
          ...state,
          loading: true,
          registrationError: null,
        }
        break
      case CREATE_USER_SUCCESS:
        state = {
          ...state,
          loading: false,
          authData: action.payload,
          registrationError: null,
        }
        break
    case VERIFY_OTP_NUMBER:
        state = {
            ...state,
            loading: true,
            registrationError: null,
        }
        break
    case VERIFY_OTP_NUMBER_SUCCESS:
        state = {
            ...state,
            loading: false,
            authData: action.payload,
            registrationError: null,
        }
        break
      case API_ERROR:
        console.log(" fail", action.payload)
        state = {
          ...state,
          authData: null,
          loading: false,
          registrationError: action.payload,
        }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default authReducer
  